import React from 'react'
import { QRCodeSVG } from 'qrcode.react'
import { getUserInfo } from '@/models/User';

const VerifyQr: React.FC = () => {
 const userInfo = getUserInfo();

 return (
  <>
   <div className="qr-code">
    {userInfo?.payload?.user?.secret ? (
     <QRCodeSVG
      value={userInfo?.payload?.user?.secret ?? ''}
      title={"QR Code Back to School FCO"}
      size={300}
      bgColor={"#ffffff"}
      fgColor={"#000000"}
      level={"H"}
      imageSettings={{
       src: "https://cdn.vn.garenanow.com/web/fo4vn//Khoa/2023/T9/COUPON/favfc.png",
       height: 80,
       width: 80,
       opacity: 1,
       excavate: true,
      }}
     />
    ): (
     <p>Đang tải dữ liệu...</p>
    )}
    <br />
    <p className='text-center'>Xác nhận bằng QR chỉ áp dụng cho việc xác nhận tài khoản tại sự kiện Offline của FC Online.Các HLV xác thực tại nhà vui lòng chọn hình thức "Xác minh bằng email sinh viên"</p>
   </div>
  </>
 )
}

export default VerifyQr